// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#145969","colorPrimaryLight5":"#8aacb4","colorPrimaryLight7":"#b9cdd2","colorPrimaryLight9":"#e8eef0"};